import * as Yup from "yup";

export const validateRowSchema = Yup.object().shape({
    tagKey: Yup
        .string()
        .required("Required"),
    tagLabel: Yup
        .string()
        .required("Required"),
    tagValue: Yup
        .string()
        .required("Required"),
    tagDescription: Yup
        .string()
        .required("Required"),
})

export const validationSchema = Yup.object({
    auditTarget: Yup
        .string()
        .required("Required"),
    moduleScope: Yup
        .string()
        .required("Required"),
    auditModule: Yup
        .string()
        .required("Required"),
    trailRef: Yup
        .string()
        .required('Required'),
    description: Yup
        .string()
        .required("Required"),
    type: Yup
        .string()
        .required("Required"),
    referId: Yup
        .string()
        .required("Required"),

    rows: Yup.array().of(validateRowSchema),
})

export const initialRowValues = {
    tagKey: "",
    tagLabel: "",
    tagValue: "",
    tagDescription: "",
}

export const initialValues = {
    auditTarget: "",
    moduleScope: "",
    auditModule: "",
    trailRef: "",
    type: "",
    description: "",
    referId: "",
    rows: [initialRowValues],
}